import script from "./dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./dialog.vue?vue&type=script&setup=true&lang=js"

import "./dialog.vue?vue&type=style&index=0&id=388a32e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-388a32e9"]])

export default __exports__